import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SingleFilterContainer } from "~/components/Filters/SingleFilters/SingleFilterContainer";
import { SmartTagsFilter } from "~/components/Filters/SmartTagsFilter/SmartTagsFilter";
import { PrivateSmartTagsSelect } from "~/components/SmartTagSelect/PrivateSmartTagsSelect";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { clearTagsFilterValuesAction, setSmartTagsFilterLogicAction, setSmartTagsFiltersValueAction } from "~/store/filters/actions";
import { hasSmartTagsFiltersValuesSelector, selectedSmartTagsFilterLogicSelector, selectedSmartTagsFiltersSelector } from "~/store/filters/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
export const SingleSmartTagFilter = /*#__PURE__*/ memo((param)=>{
    let { onApplyClick } = param;
    const { searchImprovements } = useTemporaryFeatureFlags();
    const dispatch = useDispatch();
    const hasValues = useAirSelector(hasSmartTagsFiltersValuesSelector);
    const clearValues = useCallback(()=>{
        dispatch(clearTagsFilterValuesAction());
    }, [
        dispatch
    ]);
    const selectedLogic = useSelector(selectedSmartTagsFilterLogicSelector);
    const selectedSmartTags = useSelector(selectedSmartTagsFiltersSelector);
    const onLogicChange = useCallback((logic)=>dispatch(setSmartTagsFilterLogicAction({
            logic
        })), [
        dispatch
    ]);
    const onSelectedSmartTagsChanged = useCallback((smartTags)=>{
        dispatch(setSmartTagsFiltersValueAction({
            smartTags
        }));
        if (searchImprovements) {
            onApplyClick();
        }
    }, [
        dispatch,
        onApplyClick,
        searchImprovements
    ]);
    return /*#__PURE__*/ _jsx(SingleFilterContainer, {
        hasValues: hasValues,
        currentFilter: "smartTags",
        onClearClick: clearValues,
        onApplyClick: onApplyClick,
        children: /*#__PURE__*/ _jsx(SmartTagsFilter, {
            SmartTagsSelect: PrivateSmartTagsSelect,
            selectedLogic: selectedLogic,
            selectedSmartTags: selectedSmartTags,
            onLogicChange: onLogicChange,
            onSelectedSmartTagsChanged: onSelectedSmartTagsChanged
        })
    });
});
SingleSmartTagFilter.displayName = "SingleSmartTagFilter";
